import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import GlobalAlert from "@/components/ui/GlobalAlert";
import GlobalConfirm from "@/components/ui/GlobalConfirm";
import GlobalPrompt from "@/components/ui/GlobalPrompt";
import PrimerLoginModal from "@/components/auth/PrimerLoginModal";
import LandingPage from "@/pages/LandingPage";
import Dashboard from "@/pages/Dashboard";
import Clientes from "@/pages/Clientes";
import Expedientes from "@/pages/Expedientes";
import Agenda from "@/pages/Agenda";
import Facturacion from "@/pages/Facturacion";
import Vault from "@/pages/Vault";
import Documentos from "@/pages/Documentos";
import Reportes from "@/pages/Reportes";
import Asistente from "@/pages/Asistente";
import AnalisisCasos from "@/pages/AnalisisCasos";
import SincronizacionJudicial from "@/pages/SincronizacionJudicial";
import Chat from "@/pages/Chat";
import Administracion from "@/pages/Administracion";
import Carpetas from "@/pages/Carpetas";
import Importacion from "@/pages/Importacion";
import Suscripcion from "@/pages/Suscripcion";
import SuperAdmin from "@/pages/SuperAdmin";
import ResetPassword from "@/pages/ResetPassword";
import LegalPage from "@/pages/LegalPage";

function ProtectedRoute({ children }) {
  const { user, loading, checkAuth } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#070707] flex items-center justify-center">
        <div className="text-center">
          <div className="w-12 h-12 border-2 border-[#C9A44C] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-[#888] text-sm" style={{ fontFamily: 'Outfit, sans-serif' }}>Cargando...</p>
        </div>
      </div>
    );
  }

  if (!user || user === false) return <Navigate to="/" replace />;

  // Primer login: forzar cambio de contraseña
  if (user.primer_login === true) {
    return (
      <>
        {children}
        <PrimerLoginModal onCompletado={checkAuth} />
      </>
    );
  }

  return children;
}

function AppRouter() {
  const P = (el) => <ProtectedRoute>{el}</ProtectedRoute>;
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/restablecer-password" element={<ResetPassword />} />
      <Route path="/terminos" element={<LegalPage tipo="terminos" />} />
      <Route path="/privacidad" element={<LegalPage tipo="privacidad" />} />
      <Route path="/dashboard" element={P(<Dashboard />)} />
      <Route path="/clientes" element={P(<Clientes />)} />
      <Route path="/expedientes" element={P(<Expedientes />)} />
      <Route path="/agenda" element={P(<Agenda />)} />
      <Route path="/facturacion" element={P(<Facturacion />)} />
      <Route path="/vault" element={P(<Vault />)} />
      <Route path="/carpetas" element={P(<Carpetas />)} />
      <Route path="/documentos" element={P(<Documentos />)} />
      <Route path="/asistente" element={P(<Asistente />)} />
      <Route path="/analisis-casos" element={P(<AnalisisCasos />)} />
      <Route path="/sincronizacion-judicial" element={P(<SincronizacionJudicial />)} />
      <Route path="/chat" element={P(<Chat />)} />
      <Route path="/reportes" element={P(<Reportes />)} />
      <Route path="/administracion" element={P(<Administracion />)} />
      <Route path="/importacion" element={P(<Importacion />)} />
      <Route path="/suscripcion" element={P(<Suscripcion />)} />
      <Route path="/admin" element={<SuperAdmin />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <GlobalAlert />
        <GlobalConfirm />
        <GlobalPrompt />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
